import {BaseReference} from "../../model/BaseReference";
import {NocoDbProjectProxy} from "../NocoDbProjectProxy";
import {IListingReponse} from "../ListingReponse";


export interface INocoEvaluationSection {

  Id: number;
  ProductId: number;
  Title: string;
  SectionNo: number;
  FirebaseId: string;
}

export class NocoEvaluationSection extends BaseReference<INocoEvaluationSection>{

  protected onSetValue(value: INocoEvaluationSection | null) {
  }

  constructor( value: INocoEvaluationSection | null ) {

    super( value );

    if ( value ) {
      this.value = value;
    }
  }
}


export class NocoEvaluationSectionSet {

  values: NocoEvaluationSection[] = [];
  valuesById: {[id: number]: NocoEvaluationSection} = {};

  getEvaluationSection( productId: number, sectionNo: number ): NocoEvaluationSection {

    for( const candidate of this.values ) {

      if( candidate.value.ProductId === productId && candidate.value.SectionNo === sectionNo ) {
        return candidate;
      }
    }
    return null;
  }


  public static async getValue( proxy: NocoDbProjectProxy ): Promise<IListingReponse<INocoEvaluationSection>> {

    return proxy.getView<INocoEvaluationSection>( 'EvaluationSection' );
  }


  public static async build( proxy: NocoDbProjectProxy ): Promise<NocoEvaluationSectionSet> {

    const value = await NocoEvaluationSectionSet.getValue( proxy );
    return new NocoEvaluationSectionSet(value);
  }

  public constructor( public value: IListingReponse<INocoEvaluationSection> ) {

    for( const rowValue of value.list ) {

      const reference = new NocoEvaluationSection( rowValue );
      this.values.push( reference );
      this.valuesById[rowValue.Id] = reference;
    }

  }

}

